import { Route, Routes } from "react-router-dom";
import { Home } from "../layout/home/Home";
import { About } from "../layout/about/About";
import { Demo } from "../layout/demo/Demo";
import BusinessIntelligence from "../layout/business-intelligence/BusinessIntelligence";
// import { SuccessStories } from "../layout/success-stories/SuccessStories";

export const AppRouter = () => {
  return (
    <Routes>
      <Route index element={<Home />} />
      {/* <Route element={<Home />} /> */}
      <Route path="/about" element={<About />} />
      <Route path="/demo" element={<Demo />} />
      {/* <Route path="success-stories" element={<SuccessStories />} /> */}

      <Route path="/business-intelligence" element={<BusinessIntelligence />} />
      <Route path="/*" element={<Home />} />
      {/* <Route path="*" element={<div>404 - Page not found</div>} /> */}
    </Routes>
  );
};
